import { render, staticRenderFns } from "./TheWizard.vue?vue&type=template&id=62cce09d&"
import script from "./TheWizard.vue?vue&type=script&lang=js&"
export * from "./TheWizard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports